/** Slug da aba ICMS-ST em `TAB_SLUGS` (Apuracoes/DetalheIcms/index.js). */
const TAB_ICMS_ST = "icms-st";
const DETALHE = (idRelatorioApuracao) => `/relatorios/apuracoes/${idRelatorioApuracao}/detalhe`;
// A tela de ICMS (que tem as abas, entre elas a de ICMS-ST) é outra rota, não o detalhe genérico.
const DETALHE_ICMS = (idRelatorioApuracao) => `/relatorios/apuracoes/${idRelatorioApuracao}/detalhe/icms`;

/**
 * URL do detalhe da apuração de origem de um projeto: reaplica os filtros salvos (`pf`) e, quando o
 * projeto já foi aprovado, abre o modo consulta dos itens dele (`projeto`).
 * @param {{ idProjeto: number, idRelatorioApuracao: number, idApuracaoPai?: number|null, tipo?: string, filtros?: object|null, status: string }} projeto
 * @returns {string}
 */
export function montarUrlApuracao({ idProjeto, idRelatorioApuracao, idApuracaoPai, tipo, filtros, status }) {
  // ICMS-ST: o projeto é salvo na apuração filha, que não tem tela; quem tem é o pai, na aba ICMS-ST.
  const ehIcms = tipo === "icms";
  const partes = ehIcms ? [`tab=${TAB_ICMS_ST}`] : [];
  if (filtros && typeof filtros === "object" && Object.keys(filtros).length > 0) {
    partes.push(`pf=${encodeURIComponent(JSON.stringify(filtros))}`);
  }
  if (status === "APROVADO") partes.push(`projeto=${idProjeto}`);
  const base = ehIcms ? DETALHE_ICMS(idApuracaoPai || idRelatorioApuracao) : DETALHE(idRelatorioApuracao);
  return partes.length ? `${base}?${partes.join("&")}` : base;
}

/**
 * Caminho de volta de montarUrlApuracao.
 * @param {string} [search] query string (`location.search`)
 * @returns {{ filtros: object|null, idProjeto: number|null }}
 */
export function lerParametrosProjeto(search) {
  const params = new URLSearchParams(search || "");

  let filtros = null;
  const bruto = params.get("pf");
  if (bruto) {
    try {
      const lido = JSON.parse(bruto);
      if (lido && typeof lido === "object" && !Array.isArray(lido)) filtros = lido;
    } catch {
      filtros = null;
    }
  }

  const id = Number.parseInt(params.get("projeto") ?? "", 10);
  return { filtros, idProjeto: Number.isInteger(id) && id > 0 ? id : null };
}
